<template>
  <div style="height:100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.38" :split_height="156">
      <template #main>
        <TableMain ref="OrderForecastDispatch1" name="myName" :fields="fields" :title="table_title.title1"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
          :show_toolbar="false" :show_filter="true" :selectable="true" @on_query="on_query" :isBusy="isBusy_table1"
          @current_changed="current_changed" :table_height_adjust="-8" :hb_table_class="'hb_table_ofd_add_class1'"
          :loading_width="45" :only_text="$t('common.show_all')" @only_methods="only_main_methods">
          <template #query>
            {{ $t("common.customer") + $t("common.name") }}：<el-input size="small" style="width: 120px" clearable
              v-model="CustAccountName">
            </el-input>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="OrderForecastDispatch2" :show_query_container="false" :isBusy="isBusy_table2"
          :fields="item_fields" :show_date_picker="false" :table_height_adjust="8" :title="table_title.title2"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
          :pager_count="5" :loading_width="80" :only_text="$t('common.show_all')"
          :hb_table_class="'hb_table_ofd_add_class2'" @only_methods="only_methods">
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="OrderForecastDispatch3" :fields="orderForecast_Detail_fileds" :isBusy="isBusy_table3"
          :show_query_container="false" :title="table_title.title3" :date_picker_label="date_picker_label"
          :table_height_adjust="-1" :show_filter="false" :show_pagination="show_pagination" :pager_count="5"
          :loading_width="55" @on_change="OrderForecastDispatch3_on_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
          @state_change="table3_state_change" :hb_table_class="'hb_table_ofd_add_class3'"
          @item_drop_click="item_drop_click" @item_drop_commond="item_drop_commond">
          <template #toolbar="">
            <el-select filterable clearable multiple collapse-tags reserve-keyword placeholder="供应商选择"
              :filter-method="remoteVenderMethod" class="ml-2" v-model="venders" style="width: 30rem"
              @clear="remoteVenderMethod" @remove-tag="remoteVenderMethod(venders)" @focus="remoteVenderMethod('')">
              <el-option v-for="item in vender_options" :key="item.AccountNum"
                :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum">
              </el-option>
            </el-select>
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddDispatch"><i
                class="fa fa-plus"></i></el-button>
            <el-tooltip content="更新有报价的供应商" placement="top" effect="light">
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="RefreshVendPrice(true)"><i
                  class="icon iconfont icon-refresh"></i></el-button>
            </el-tooltip>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveDispatch"
              :label="$t('common.save')" class="ml-2">
            </QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="choseVendData" :width="'60%'" :saveButtonTitle="'确 定'">
      <template #modal_content>
        <BaseContainer style="height:100%" class="one_table">
          <div>
            <TableMain ref="VendQuoteTable" name="myName" :id="'vend_quote'" :fields="vendQuote_fields"
              :title="vendQuoteModal_title" :date_picker_label="date_picker_label" :query_button_label="query_lable"
              :loading_width="85" :show_query_container="false" :show_date_picker="true" :show_toolbar="false"
              :show_filter="true" :selectable="true" :isBusy="isBusy_VendQuoteTable"
              @on_change="VendQuoteTable_on_change" @item_select_change="item_select_change" :table_height_adjust="8"
              :table_height_default="'calc(100vh - 520px)'" :hb_table_class="'hb_table_vend_quote_sfd_add_class'">
            </TableMain>
          </div>
        </BaseContainer>
      </template>
    </BaseModal>
    <!-- 进度 -->
    <BaseModal ref="progressModal" :title="progress_modal_title" :hideFooter="true" :show_close="false" :top="'40vh'">
      <template #modal_content>
        <BaseProgress ref="progress"></BaseProgress>
      </template>
    </BaseModal>
  </div>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
import TableDetail from "../components/table/TableDetail"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import SplitContainer3 from "../components/container/SplitContainer3"
import SplitContainer2 from "../components/container/SplitContainer2"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as OrderForecastDispatchAddController from "../../controllers/sd/OrderForecastDispatchAddController"
import * as VendPurchaseQuoteOutController from "../../controllers/sd/VendPurchaseQuoteOutController"
import * as OrderForecastController from "../../controllers/sd/OrderForecastController"
import * as VendTableController from "../../controllers/base/VendTableController"
import BaseModal from "../components/modals/baseModal"
import BaseProgress from "../components/base/BaseProgress"

export default {
  name: "OrderForecastDispatchAdd",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer3,
    SplitContainer2,
    BaseModal,
    BaseProgress
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_forecast",
        title2: "table_forecast_detail",
        title3: "table_create_forecast",
      },
      modal_title: "create_forecast_order",
      progress_modal_title: this.$t("common.progress") + "...",
      vendQuoteModal_title: "table_vend",
      isBusy_VendQuoteTable: false,
      fields: OrderForecastDispatchAddController.fields.default,
      item_fields: OrderForecastDispatchAddController.fields.item_fields,
      orderForecast_Detail_fileds:
        OrderForecastDispatchAddController.fields.orderForecast_Detail_fileds,
      vendQuote_fields:
        OrderForecastDispatchAddController.fields.vend_quote_fileds,
      show_pagination: false,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      CustAccountName: "",
      company_options: [],
      vender_options: [],
      vender_his_options: [],
      company_id: [],
      venders: [],
      sfHisData: [],
      his_group_price_list: null, ///供应商采购报价 临时存储
      selectItem: null,
    }
  },
  activated() { },
  deactivated() { },
  created() {
    let _fields = _.find(this.orderForecast_Detail_fileds, { key: "ModelId" })
    _.remove(_fields, (n) => {
      return n == "id"
    })
    _fields["_options"] = {
      provider: (v) => {
        let order_m = this.$refs.OrderForecastDispatch1.GetCurrentItem()
        let sf_models = _.filter(
          this.$store.state.biz_data.baseData.ForecastModel,
          { dataAreaId: order_m.dataAreaId }
        )
        return _.map(sf_models, (v) => {
          return {
            value: v.ModelId,
            label: v.ModelId + ": " + v.Txt,
          }
        })
      },
    }
    let _fieldModal = _.find(this.vendQuote_fields, { key: "ModelId" })
    _.remove(_fieldModal, (n) => {
      return n == "id"
    })
    _fieldModal["_options"] = {
      provider: (v) => {
        let order_m = this.$refs.OrderForecastDispatch1.GetCurrentItem()
        let sf_models = _.filter(
          this.$store.state.biz_data.baseData.ForecastModel,
          { dataAreaId: order_m.dataAreaId }
        )
        return _.map(sf_models, (v) => {
          return {
            value: v.ModelId,
            label: v.ModelId + ": " + v.Txt,
          }
        })
      },
    }
    let _field = _.find(this.orderForecast_Detail_fileds, {
      key: "AccountNum",
    })
    _field["_dropoptions"] = {
      base_on_field: "AccountNum",
      dropdownSearchValue: "",
      items: [],
      provider: (v) => {
        return _.map(this.setVendOptionsData(v), (t) => {
          return {
            value: t.AccountNum,
            label: t.AccountNum + "：" + t.SEI_Name,
          } //VariantName
        })
      },
    }
  },
  computed: {
    selectSOLineItems() {
      return this.$refs.OrderForecastDispatch2.GetSelectedItems()
    },
    baseCompanyInfo() {
      return this.$store.state.biz_data.baseData.CompanyInfo
    },
    baseVender() {
      return this.$store.state.biz_data.baseData.Vender
    },
  },
  watch: {
    baseCompanyInfo(newV, oldV) {
      if (newV) {
        this.company_options = _.cloneDeep(newV).splice(0, 300)
      }
    },
    baseVender(newV, oldV) {
      if (newV) {
        this.vender_options = _.cloneDeep(
          _.orderBy(newV, ["modifiedDateTime"], ["desc"])
        ).splice(0, 300)
      }
    },
  },

  mounted() {
    //this.getOptions();
  },
  methods: {
    //预加载部分options
    getOptions() {
      this.company_options = _.cloneDeep(
        this.$store.state.biz_data.baseData.CompanyInfo
      ).splice(0, 300)
      this.vender_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.baseData.Vender,
          ["modifiedDateTime"],
          ["desc"]
        )
      ).splice(0, 300)
    },
    //公司选择
    remoteMethod(query) {
      if (query !== "") {
        this.loadingSelected = true
        this.company_options = _.cloneDeep(
          this.$store.state.biz_data.baseData.CompanyInfo.filter((item) => {
            return (
              item.DataArea.toLowerCase().indexOf(query.toLowerCase()) > -1
            )
          })
        ).splice(0, 300)
        this.loadingSelected = false
      } else {
        let data = _.cloneDeep(
          this.$store.state.biz_data.baseData.CompanyInfo
        ).splice(0, 300)
        this.company_options = data
      }
    },
    //供应商选择
    remoteVenderMethod(query) {
      console.log(query)
      if (_.isArray(query)) {
        if (query.length == 0) {
          query = ""
        } else {
          return
        }
      }

      if (query && query !== "") {
        this.loadingSelected1 = true
        let _filter_list = _.orderBy(
          this.vender_his_options,
          ["modifiedDateTime"],
          ["desc"]
        ).filter((item) => {
          return (
            item.AccountNum.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
            item.SEI_Name.indexOf(query) > -1
          )
        })
        this.vender_options = _.cloneDeep(_filter_list).splice(0, 300)
        this.loadingSelected1 = false
      } else {
        let data = _.cloneDeep(
          _.orderBy(this.vender_his_options, ["modifiedDateTime"], ["desc"])
        ).splice(0, 300)
        this.vender_options = data
      }
    },
    ///查询
    async on_query(set_data, date_range) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "s-sPlant_OrderForecast",
      // ]);
      // if (!ckp) {
      //   this.$refs.OrderForecastDispatch2.SetData([]);
      //   return;
      // }
      set_data([])
      let _this = this
      this.selectItem = null
      this.venders = []
      this.$refs.OrderForecastDispatch2.SetData([])
      this.$refs.OrderForecastDispatch3.SetData([])
      this.isBusy_table1 = true
      let _fromDate = "",
        _toDate = ""
      let _params = {
        is_deleted: { "=": 0 },
        CustAccountName: { like: "%" + this.CustAccountName + "%" },
      }
      if (!_.isNull(date_range) && this.CustAccountName == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }
      let _result = await OrderForecastController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = []
        _.each(_result[0], (t) => {
          let _index = _.findIndex(
            _this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccountId }
          )
          if (_index > -1 && t.fcCheckSFApproved == true) {
            _list.push(t)
          }
        })
        this.sfHisData = _.orderBy(_list, ["id"], ["desc"])
        this.only_main_methods(this.$refs.OrderForecastDispatch1.only_value)
      }
      this.isBusy_table1 = false
    },
    ///销售订单选择
    async current_changed(old, current) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "s-VendTable",
      //   "e-get_orderforecast_line",
      // ]);
      // if (!ckp) {
      //   this.$refs.OrderForecastDispatch2.SetData([]);
      //   this.$refs.OrderForecastDispatch3.SetData([]);
      //   return;
      // }
      if (_.isNull(current)) {
        this.$refs.OrderForecastDispatch3.SetData([])
        this.$refs.OrderForecastDispatch2.SetData([])
        return
      }

      this.$refs.OrderForecastDispatch3.SetData([])
      this.$refs.OrderForecastDispatch2.SetData([])
      this.venders = []

      this.isBusy_table2 = true
      //get items
      let _isAll = this.$refs.OrderForecastDispatch2.only_value
      await this.getItems(_isAll)
      this.isBusy_table2 = false
      await this.getVenders(current)
    },
    ///获取供应商
    async getVenders(current) {
      let _result = await VendTableController.methods.getItemOptions({
        dataAreaId: { "=": current.dataAreaId },
        Blocked: { "=": "否" },
      })

      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.vender_options = _.cloneDeep(
          _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
        )
        this.vender_his_options = _.cloneDeep(
          _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
        )
      }
    },
    async getItems(isAll) {
      let current = this.$refs.OrderForecastDispatch1.GetCurrentItem()
      let _p = {
        order_forecast_id: current.id,
      }

      let _result =
        await OrderForecastDispatchAddController.methods.getItemData(_p)

      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = _.filter(_result[0], function (t) {
          if (!t.is_deleted && !t.is_cancel) {
            if (isAll) {
              if (t.valid_remain > 0 || t.valid_remain == 0) {
                return t
              }
            } else {
              if (t.valid_remain > 0) {
                return t
              }
            }
          }
        })
        this.$refs.OrderForecastDispatch2.SetData(
          _.orderBy(_list, ["id"], ["asc"])
        )
      }
    },

    //添加派发
    async AddDispatch() {
      this.remoteVenderMethod('')
      if (this.selectSOLineItems.length == 0) {
        this.msgToasts(this.$t("notify.not_selected_sales_order_detail"), "info")
        return
      }
      if (this.selectSOLineItems && this.selectSOLineItems.length > 0) {
        this.isBusy_table3 = true
        ///重新获取供应商报价
        await this.RefreshVendPrice(false)
        this.saleOrderChooseBatch()
      }
    },
    //批量添加派发
    async saleOrderChooseBatch() {
      let _this = this
      let _append_items = []

      if (this.venders.length > 0) {
        let order_seq = this.$refs.OrderForecastDispatch3.my_data.length
        _.each(this.venders, (t) => {
          _.each(_this.selectSOLineItems, (d) => {
            let _m = _.cloneDeep(OrderForecastDispatchAddController.dataForm)
            _m.id = ""
            _m.AccountNum = ""
            _m.SEI_Name = ""
            _m.OrderForecast_Line_id = d.id //销售订单明细
            _m.ItemId = d.ItemId
            _m.NameAlias = d.NameAlias
            _m.price = 0
            _m.qty = d.valid_remain
            _m.Capacity = 0
            _m.delivery_date = _this.formatDate(d.StartDate)
            _m.TotalScore = 0
            _m.RetailVariantId = d.RetailVariantId
            _m.VariantName = d.VariantName
            _m.ModelId = d.ModelId
            _m.SEI_ForecastSalesType = d.SEI_ForecastSalesType

            _m.order_seq = order_seq
            order_seq += 1
            ///供应商相关信息
            let vend_m = _.find(_this.$store.state.biz_data.baseData.Vender, {
              AccountNum: t,
            })
            if (vend_m) {
              _m.AccountNum = vend_m.AccountNum
              _m.SEI_Name = vend_m.SEI_Name
              _m.TotalScore = vend_m.TotalScore ///供应商评价
            }
            _m.SEI_CP_ReplenishmentCommit = d.SEI_CP_ReplenishmentCommit
            _m.WeekName = d.WeekName
            _append_items.push(_m)
          })
        })
      } else {
        let order_seq = this.$refs.OrderForecastDispatch3.my_data.length
        _.each(_this.selectSOLineItems, (d) => {
          let _m = _.cloneDeep(OrderForecastDispatchAddController.dataForm)
          _m.id = ""
          _m.AccountNum = ""
          _m.SEI_Name = ""
          _m.OrderForecast_Line_id = d.id //销售订单明细
          _m.ItemId = d.ItemId
          _m.NameAlias = d.NameAlias
          _m.price = 0
          _m.qty = d.valid_remain
          _m.Capacity = 0
          _m.delivery_date = _this.formatDate(d.StartDate)
          _m.TotalScore = 0
          _m.RetailVariantId = d.RetailVariantId
          _m.VariantName = d.VariantName
          _m.ModelId = d.ModelId
          _m.SEI_ForecastSalesType = d.SEI_ForecastSalesType

          _m.order_seq = order_seq
          _m.SEI_CP_ReplenishmentCommit = d.SEI_CP_ReplenishmentCommit
          _m.WeekName = d.WeekName
          order_seq += 1

          _append_items.push(_m)
        })
      }
      if (this.$refs.OrderForecastDispatch3.my_data.length > 0) {
        this.$refs.OrderForecastDispatch3.AppendItems(_append_items)
      } else {
        this.$refs.OrderForecastDispatch3.SetData(_append_items)
      }
      if (
        this.$refs.OrderForecastDispatch3.my_data &&
        this.$refs.OrderForecastDispatch3.my_data.length > 50
      ) {
        this.show_pagination = true
      }
      this.isBusy_table3 = false
      await this.setDisDataStateAndInfo("OrderForecastDispatch3", [
        "qty",
        "delivery_date",
      ])

    },

    ///获取或设置派单相关信息
    async setDisDataStateAndInfo(table_ref, woFields, current_item) {
      let list_params = []
      let _p = {
        get_pc: [],
        check_vend_has_invent: [],
        invent_sum_params: [],
      }

      if (current_item) {
        ///获取产能
        _p.get_pc.push({
          AccountNum: current_item.AccountNum,
          delivery_date: current_item.delivery_date,
          _seq: current_item.order_seq,
        })

        //检查是否包含物料
        let _companyid = 0
        //查找供应商公司编码
        let _company = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          VenderAccountNum: current_item.AccountNum,
        })
        if (_company) {
          _companyid = _company.DataArea
        }
        _p.check_vend_has_invent.push({
          dataAreaId: _companyid,
          ItemId: current_item.ItemId,
          _seq: current_item.order_seq,
        })

        ///供应商现有库存量
        let _invent_sum_m = {
          AccountNum: current_item.AccountNum,
          ItemId: current_item.ItemId,
          _seq: current_item.order_seq,
        }
        _p.invent_sum_params.push(_invent_sum_m)
        list_params.push(_p)
      }
      else {

        _.each(this.$refs[table_ref].my_data, (t) => {
          // _p = {
          //   get_pc: [],
          //   check_vend_has_invent: [],
          //   invent_sum_params: [],
          // };
          ///获取产能
          _p.get_pc.push({
            AccountNum: t.AccountNum,
            delivery_date: t.delivery_date,
            _seq: t.order_seq,
          })
          //检查是否包含物料
          let _companyid = 0
          //查找供应商公司编码
          let _company = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
            VenderAccountNum: t.AccountNum,
          })
          if (_company) {
            _companyid = _company.DataArea
          }
          _p.check_vend_has_invent.push({
            dataAreaId: _companyid,
            ItemId: t.ItemId,
            _seq: t.order_seq,
          })

          ///供应商现有库存量
          let _invent_sum_m = {
            AccountNum: t.AccountNum,
            ItemId: t.ItemId,
            _seq: t.order_seq,
          }
          _p.invent_sum_params.push(_invent_sum_m)
          // list_params.push(_.cloneDeep(_p))
        })
      }


      let _table3_list = this.$refs[table_ref].my_data
      let loading = null
      if (!current_item && this.$refs[table_ref].my_data.length > 100) {
        loading = this.$loading({
          lock: true,
          text: this.$t("notify.searching_price_capacity"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
      }
      let _result = await OrderForecastDispatchAddController.methods.getDisDataStateAndInfo(_p)

      if (!_.isNull(_result) && _result) {
        if (!current_item && this.$refs[table_ref].my_data.length > 100) {
          loading.setText(this.$t("notify.init_price_capacity"))
          this.$forceUpdate()
        }
        let m_setting = []
        ///设置产能
        let _filter_pc = _.filter(_result, {
          Code: "data/e/get_vend_production_capacity",
        })
        _.each(_filter_pc, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            if (t.Result.Data && !_.isNull(t.Result.Data)) {
              for (var i in t.Result.Data) {
                if (!_.isNull(t.Result.Data[i][0].ProductionCapacity)) {
                  let _m = _.cloneDeep(
                    _.find(_table3_list, { order_seq: t.Params[i]._seq })
                  )
                  if (_m) {
                    _m.Capacity = t.Result.Data[i][0].ProductionCapacity.toFixed(2)
                    m_setting.push({
                      by: { order_seq: t.Params[i]._seq },
                      m: _m,
                      wf: woFields
                    })
                  }
                }
              }
            }
          }
        })

        ///检查是否包含物料
        let _filter_has = _.filter(_result, {
          Code: "data/e/check_isExiste_vend_item",
        })
        _.each(_filter_has, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            if (t.Result.Data && !_.isNull(t.Result.Data)) {
              for (var i in t.Result.Data) {
                if (t.Params.dataAreaId != 0 && t.Result.Data[i][0].is_check_ok != 0) {
                  let _m = _.cloneDeep(_.find(_table3_list, { order_seq: t.Params[i]._seq }))
                  _m._error = true
                  m_setting.push({
                    by: { order_seq: t.Params[i]._seq },
                    m: _m,
                    wf: ["delivery_date"]
                  })
                }
              }
            }
          }
        })

        ///查询现有库存量
        let _filter_invent_sum = _.filter(_result, {
          Code: "data/e/get_vend_invent_sum",
        })
        _.each(_filter_invent_sum, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            if (t.Result.Data && !_.isNull(t.Result.Data)) {
              for (var i in t.Result.Data) {
                if (!_.isNull(t.Result.Data[i][0].AvailPhysical)) {
                  let _seq = t.Params[i]._seq
                  let _m = _.cloneDeep(_.find(_table3_list, { order_seq: _seq }))
                  if (_m) {
                    _m.invent_sum = _.round(t.Result.Data[i][0].AvailPhysical, 6)
                    m_setting.push({
                      by: { order_seq: _seq },
                      m: _m,
                      wf: woFields
                    })
                  }
                }
              }
            }
          }
        })
        for (var item in m_setting) {
          this.$refs[table_ref].UpdateItemsWOField(item.by, item.m, item.wf)
        }
        if (!current_item && this.$refs[table_ref].my_data.length > 100) {
          loading.close()
        }
        // setTimeout(() => {
        //   let step = 1
        //   for (var item in m_setting) {
        //     this.$refs[table_ref].UpdateItemsWOField(item.by, item.m, item.wf);
        //     step += 100 / m_setting.length
        //     if (!current_item && step >= 1 && this.$refs[table_ref].my_data.length > 100) {
        //       this.$refs.progress.increase(1)
        //       step = 0
        //     }
        //   }
        //   this.$refs.progressModal.cancel()
        // }, 500);
      }
    },

    //保存派发
    async saveDispatch(cb) {
      let _this = this
      if (this.$refs.OrderForecastDispatch3.my_data.length == 0) {
        cb(true)
        return
      }
      //检查数量
      let _qty_check_index = _.findIndex(
        this.$refs.OrderForecastDispatch3.my_data,
        function (t) {
          return t.qty == 0 || t.qty == ""
        }
      )
      if (_qty_check_index > -1) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        cb(false)
        return
      }
      //数据检测
      let _is_check_ok = await this.validData(
        this.$refs.OrderForecastDispatch3.my_data
      )
      if (!_is_check_ok) {
        cb(true)
        return
      }

      let _list = []
      // let _update_soline_form_list = [];
      let data = _.cloneDeep(this.$refs.OrderForecastDispatch3.my_data)
      let seq = 1
      _.each(data, (t) => {
        let _m = _.cloneDeep(OrderForecastDispatchAddController.dataForm)
        for (var i in _m) {
          _m[i] = t[i]
        }
        if (t.delivery_date && _.isDate(t.delivery_date)) {
          _m.delivery_date = _this.$date.format(t.delivery_date, "yyyy-MM-dd")
        }

        //查找供应商公司编码
        let _company = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          VenderAccountNum: t.AccountNum,
        })

        if (_company) {
          _m.DataArea = _company.DataArea
        }

        _m.seq = seq
        _m.documentCreateByUsername = this.$global.global_data.local_username
        delete _m.order_seq
        _list.push(_m)
        seq += 1

        // let _update_soline_form = {
        //   id: t.OrderForecast_Line_id,
        // };
        // let _index = _.findIndex(_update_soline_form_list, {
        //   id: t.OrderForecast_Line_id,
        // });
        // if (_index < 0) {
        //   _update_soline_form_list.push(_update_soline_form);
        // }
      })
      if (_list.length > 100) {
        this.$refs.progressModal.show()
        this.$forceUpdate()
      }
      let is_all_ok = false
      let step = 1
      for (var i in _list) {
        let items = []
        let _update_soline_form_list = []
        items.push(_list[i])
        let _update_soline_form = {
          id: _list[i].OrderForecast_Line_id,
        }
        let _index = _.findIndex(_update_soline_form_list, {
          id: _list[i].OrderForecast_Line_id,
        })
        if (_index < 0) {
          _update_soline_form_list.push(_update_soline_form)
        }
        let _rel_save_data = await OrderForecastDispatchAddController.methods.saveDispatch(items, _update_soline_form_list)
        if (!_.isNull(_rel_save_data)) {
          let _is_ok = true
          _.each(_rel_save_data, (t) => {
            if (!_.isNull(t.Result) && t.Result.Rollback) {
              _is_ok = false
            }
          })
          if (_is_ok) {
            ///成功
            is_all_ok = true
            ///设置订单明细剩余数量
            let _rdata = _.filter(_rel_save_data, {
              Code: "data/e/update_sfl_validremain",
            })
            _.each(_rdata, (t) => {
              let m = _.find(_this.$refs.OrderForecastDispatch2.my_data, {
                id: t.Params[0].SForecastLineId,
              })
              if (m) {
                m.valid_approve = t.Result.Data[0][0].valid_approve
                m.valid_remain = t.Result.Data[0][0].valid_remain
              }
            })
            this.selectItem = null
            this.remoteVenderMethod()
            this.venders = []
          } else {
            ///检查订单是否已经反审
            let is_ok1 = true
            let check_list1 = _.filter(_rel_save_data, {
              Code: "data/e/CheckIfCanModifySalesForcastDispatch", //"data/e/check_isExiste_vend_item",
            })
            _.each(check_list1, (t) => {
              if (!_.isNull(t.Result)) {
                if (t.Result.Rollback) {
                  is_ok1 = false
                }
              }
            })
            if (!is_ok1) {
              this.msgToasts(this.$t("notify.so_unapproved_not_dispatch"), "info")
            }

            ///检查订单是否已经反审
            let is_ok3 = true
            let check_list3 = _.filter(_rel_save_data, {
              Code: "data/i/sPlant_OrderForecast_Dispatch",
            })
            _.each(check_list3, (t) => {
              if (!_.isNull(t.Result) && t.Result.Rollback) {
                is_ok3 = false
              }
            })
            if (!is_ok3) {
              this.msgToasts(this.$t("notify.pcs_not_more_valid_dispatched_pcs"), "info")
            }
            break
          }
          step += 100 / _list.length
          if (_list.length > 100 && step >= 1) {
            this.$refs.progress.increase(1)
            step = 0
          }
        }
      }
      if (_list.length > 100) {
        this.$refs.progressModal.cancel()
      }
      if (is_all_ok) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.$refs.OrderForecastDispatch3.SetData([])
      }

      // let _rel_save_data = await OrderForecastDispatchAddController.methods.saveDispatch(_list, _update_soline_form_list);
      // if (!_.isNull(_rel_save_data)) {
      //   let _is_ok = true;
      //   _.each(_rel_save_data, (t) => {
      //     if (!_.isNull(t.Result) && t.Result.Rollback) {
      //       _is_ok = false;
      //     }
      //   });
      //   if (_is_ok) {
      //     ///成功
      //     this.msgToasts(this.$t("notify.action_successfully"), "success");
      //     //清空派单表
      //     this.$refs.OrderForecastDispatch3.SetData([]);
      //     ///设置订单明细剩余数量
      //     let _rdata = _.filter(_rel_save_data, {
      //       Code: "data/e/update_sfl_validremain",
      //     });
      //     _.each(_rdata, (t) => {
      //       let m = _.find(_this.$refs.OrderForecastDispatch2.my_data, {
      //         id: t.Params[0].SForecastLineId,
      //       });
      //       if (m) {
      //         m.valid_approve = t.Result.Data[0][0].valid_approve;
      //         m.valid_remain = t.Result.Data[0][0].valid_remain;
      //       }
      //     });
      //     this.selectItem = null;
      //     this.remoteVenderMethod();
      //     this.venders = [];
      //   } else {
      //     ///检查订单是否已经反审
      //     let is_ok1 = true;
      //     let check_list1 = _.filter(_rel_save_data, {
      //       Code: "data/e/CheckIfCanModifySalesForcastDispatch", //"data/e/check_isExiste_vend_item",
      //     });
      //     _.each(check_list1, (t) => {
      //       if (!_.isNull(t.Result)) {
      //         if (t.Result.Rollback) {
      //           is_ok1 = false;
      //         }
      //       }
      //     });
      //     if (!is_ok1) {
      //       this.msgToasts(this.$t("notify.so_unapproved_not_dispatch"), "info");
      //     }

      //     ///检查订单是否已经反审
      //     let is_ok3 = true;
      //     let check_list3 = _.filter(_rel_save_data, {
      //       Code: "data/i/sPlant_OrderForecast_Dispatch",
      //     });
      //     _.each(check_list3, (t) => {
      //       if (!_.isNull(t.Result) && t.Result.Rollback) {
      //         is_ok3 = false;
      //       }
      //     });
      //     if (!is_ok3) {
      //       this.msgToasts(this.$t("notify.pcs_not_more_valid_dispatched_pcs"), "info");
      //     }
      //   }
      // } else {
      //   this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
      // }
      cb(true)
    },
    //数据检验
    async validData(data) {
      ////======派单数量与剩余派单数量检查
      // let _is_more_valid = false;
      // if (this.selectSOLineItems.length > 0) {
      //   //批量派单
      //   _.each(this.selectSOLineItems, (t) => {
      //     let sum_dispathch = 0;
      //     let _t_filter = _.filter(data, { ItemId: t.ItemId });
      //     if (_t_filter && _t_filter.length > 0) {
      //       _.each(_t_filter, (m) => {
      //         m.qty = parseFloat(m.qty);
      //       });
      //       sum_dispathch = _.sumBy(_t_filter, "qty");
      //     }
      //     if (sum_dispathch > t.valid_remain) {
      //       _is_more_valid = true;
      //     }
      //   });
      // } else {
      //   //非批量派单
      //   let _soline_current = this.$refs.OrderForecastDispatch2.GetCurrentItem();
      //   if (_soline_current) {
      //     let _list = _.cloneDeep(this.$refs.OrderForecastDispatch3.my_data);
      //     _.each(_list, (m) => {
      //       m.qty = parseFloat(m.qty);
      //     });
      //     let sum_dispathch = _.sumBy(_list, "qty");
      //     if (sum_dispathch > _soline_current.valid_remain) {
      //       _is_more_valid = true;
      //     }
      //   }
      // }
      // if (_is_more_valid == true) {
      //   this.msgToasts(this.$t("notify.pcs_not_more_valid_dispatched_pcs"), "error");
      //   return false;
      // }

      return true
    },

    ///数量改变
    async OrderForecastDispatch3_on_change(data) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_vend_production_capacity",
      //   "e-check_isExiste_vend_item",
      //   "e-get_vend_invent_sum",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      if (data.field.key == "delivery_date") {
        this.setDisDataStateAndInfo("OrderForecastDispatch3", [
          "qty",
          "delivery_date",
        ], data.item)
      }
    },

    table3_state_change(data, cb) {
      if (data.state === "deleted") {
        this.$refs.OrderForecastDispatch3.RemoveItems(data.selected_items)
      }
    },
    async only_main_methods(only_value) {
      this.$refs.OrderForecastDispatch2.SetData([])
      this.$refs.OrderForecastDispatch3.SetData([])
      this.$refs.OrderForecastDispatch2.only_value = false
      //筛选未完成的
      let _dt = _.filter(_.cloneDeep(this.sfHisData), (t) => {
        if (!t.fcCheckIsOrderForecastAllDispatched) {
          return t
        }
      })
      if (!only_value) {
        this.$refs.OrderForecastDispatch1.SetData(_dt)
      }
      else {
        this.$refs.OrderForecastDispatch1.SetData(_.cloneDeep(this.sfHisData))
      }

    },
    async only_methods(only_value) {
      await this.getItems(only_value)
    },
    setVendOptionsData(dropdownSearchValue) {
      let _list = _.cloneDeep(this.vender_options)
      if (dropdownSearchValue && dropdownSearchValue != "") {
        _list = _.cloneDeep(
          _.orderBy(
            this.$store.state.biz_data.baseData.Vender,
            ["modifiedDateTime"],
            ["desc"]
          )
        )
        let current = this.$refs.OrderForecastDispatch1.GetCurrentItem()
        ///编号只能是等于
        _list = _.filter(_list, function (t) {
          if (t.dataAreaId == current.dataAreaId) {
            if (
              t.AccountNum == dropdownSearchValue ||
              t.SEI_Name.indexOf(dropdownSearchValue) > -1
            ) {
              return t
            }
          }

        })
      }
      return _list.splice(0, 10)
    },
    ///弹出供应商选择
    async item_drop_click(data) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_vend_production_capacity",
      //   "e-check_isExiste_vend_item",
      //   "e-get_vend_invent_sum",
      // ]);
      // if (!ckp) {
      //   this.$refs.VendQuoteTable.SetData([]);
      //   return;
      // }
      let _this = this
      this.current_dispatch_line = data.item
      this.modal_title = this.$t("common.invent") + "（" + data.item.ItemId + "：" + data.item.NameAlias + "）"
      this.$refs.bvModal.show()

      this.isBusy_VendQuoteTable = true
      let _list = []
      for (var i in this.his_group_price_list) {
        let _m = _.cloneDeep(OrderForecastDispatchAddController.dataForm)
        for (var k in _m) {
          for (var j in this.his_group_price_list[i][0]) {
            if (k === j) {
              _m[k] = this.his_group_price_list[i][0][k]
            }
          }
        }
        let _index = _.findIndex(this.vender_his_options, {
          AccountNum: _m.AccountNum,
        })
        if (_index > -1) {
          _list.push(_m)
        }
      }

      let _order_seq = 0
      _.each(_list, (t) => {
        t.ItemId = data.item.ItemId
        t.ModelId = data.item.ModelId
        t.SEI_ForecastSalesType = data.item.SEI_ForecastSalesType
        t.Capacity = 0
        t.delivery_date = this.$date.format(
          new Date(data.item.delivery_date),
          "yyyy-MM-dd"
        )
        t.qty = data.item.qty
        t.order_seq = _order_seq

        ///供应商相关信息
        let vend_m = _.find(_this.$store.state.biz_data.baseData.Vender, {
          AccountNum: t.AccountNum,
        })
        if (vend_m) {
          t.TotalScore = vend_m.TotalScore
        }
        _order_seq += 1
      })

      this.$forceUpdate()
      setTimeout(async () => {
        this.$refs.VendQuoteTable.SetData(_list)
        setTimeout(async () => {
          await this.setDisDataStateAndInfo("VendQuoteTable")
          let _order_list = _.cloneDeep(this.$refs.VendQuoteTable.my_data)
          this.$refs.VendQuoteTable.SetData(
            _.orderBy(_order_list, ["price"], ["asc"])
          )
          this.isBusy_VendQuoteTable = false
        }, 200)
      }, 500)
      // this.$forceUpdate()
    },
    choseVendData(cb) {
      if (!_.isNull(this.current_dispatch_line)) {
        let _select_list = this.$refs.VendQuoteTable.GetSelectedItems()
        if (_select_list && _select_list.length > 0) {
          this.current_dispatch_line.AccountNum = _select_list[0].AccountNum
          this.current_dispatch_line.SEI_Name = _select_list[0].SEI_Name
          this.current_dispatch_line.qty = _select_list[0].qty
          this.current_dispatch_line.delivery_date =
            _select_list[0].delivery_date
          this.current_dispatch_line.Capacity = _select_list[0].Capacity
          this.current_dispatch_line.TotalScore = _select_list[0].TotalScore
          this.current_dispatch_line._error = _select_list[0]._error
          this.current_dispatch_line.ModelId = _select_list[0].ModelId
          this.current_dispatch_line.SEI_ForecastSalesType =
            _select_list[0].SEI_ForecastSalesType
          this.current_dispatch_line.invent_sum = _select_list[0].invent_sum
        } else {
          this.msgToasts(this.$t("notify.select_provider"), "info")
          cb(null)
          return
        }
      }
      cb(false)
      this.$refs.bvModal.cancel()
    },
    async VendQuoteTable_on_change(data) {
      if (data.field.key == "delivery_date") {
        this.setDisDataStateAndInfo(
          "VendQuoteTable",
          ["qty", "price", "delivery_date"],
          data.item
        )
      }
    },
    item_select_change(item) {
      this.$refs.VendQuoteTable.UnSelectAll()
      let _m = _.cloneDeep(item)
      let _item_list = []
      _item_list.push(_m)
      this.$refs.VendQuoteTable.setItemSelect(_item_list, true)
    },
    async item_drop_commond(commond) {
      let _this = this
      if (commond) {
        ///设置值
        let _id = _.split(commond, "#", 2)[1]
        let _m = _.find(this.$refs.OrderForecastDispatch3.my_data, {
          _id: parseInt(_id),
        })
        if (_m) {
          let _accountNum = _.split(commond, "#", 2)[0]
          ///供应商相关信息
          let vend_m = _.find(_this.$store.state.biz_data.baseData.Vender, {
            AccountNum: _accountNum,
          })
          if (vend_m) {
            _m.AccountNum = vend_m.AccountNum
            _m.SEI_Name = vend_m.SEI_Name
            _m.TotalScore = vend_m.TotalScore
          }
          _m._error = false
          await this.setDisDataStateAndInfo("OrderForecastDispatch3", [], _m)
        }
      }
    },
    async getItemPrice(ItemIds) {
      let _this = this
      let _result = await VendPurchaseQuoteOutController.methods.getSimpleData({
        ItemId: { in: ItemIds },
        is_approved: { "=": 1 },
        is_deleted: { "=": 0 },
      })
      this.his_group_price_list = null
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _price_list = _.orderBy(
          _result[0].Result.Data[0],
          ["AccountNum", "QuantityAmountFrom"],
          ["asc", "desc"]
        )

        ///初始化对比数据
        _.each(_price_list, (t) => {
          if (!_.isNull(t.FromDate)) {
            t.FromDate = _this.$date.format(new Date(t.FromDate), "yyyy-MM-dd")
          } else {
            t.FromDate = "1900-01-01"
          }

          if (!_.isNull(t.ToDate)) {
            t.ToDate = _this.$date.format(new Date(t.ToDate), "yyyy-MM-dd")
          } else {
            t.ToDate = "2099-12-31"
          }

          if (t.QuantityAmountFrom == 0 || _.isNull(t.QuantityAmountFrom)) {
            t.QuantityAmountFrom = 0
          }

          if (t.QuantityAmountTo == 0 || _.isNull(t.QuantityAmountTo)) {
            t.QuantityAmountTo = Number.MAX_VALUE
          }
        })
        let _group_price_list = _.groupBy(_price_list, "AccountNum")
        this.his_group_price_list = _group_price_list
        console.log(_group_price_list)
      }
    },
    ///刷新价格
    async RefreshVendPrice(isShowNotice) {
      let _items = _.keys(
        _.keyBy(this.$refs.OrderForecastDispatch2.my_data, "ItemId")
      )

      await this.getItemPrice(_items)
      if (isShowNotice) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
    },
  },
}
</script>
<style>
.hb_table_ofd_add_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 105rem;
}

.hb_table_ofd_add_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}

.hb_table_ofd_add_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 120rem;
}

.hb_table_vend_quote_sfd_add_class {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 95rem;
}
</style>
<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
